import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Envelope } from "@phosphor-icons/react";

export default function ConfirmEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: "pending", email: null, message: "Confirming your email…" });

  useEffect(() => {
    if (!token) { setState({ status: "error", message: "Confirmation link is missing a token." }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/confirm-email", { token });
        setState({ status: "ok", email: data.email, message: "Your email is confirmed. You can now sign in." });
      } catch (err) {
        setState({ status: "error", message: formatApiError(err) });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md" data-testid="confirm-email-page">
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="rounded-full bg-primary/10 p-2"><Envelope size={20} className="text-primary" /></div>
            <CardTitle>Email confirmation</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          {state.status === "pending" && (
            <div className="flex items-center gap-3">
              <div className="h-6 w-6 rounded-full border-2 border-primary/20 border-t-primary animate-spin" />
              <span className="text-sm text-muted-foreground">{state.message}</span>
            </div>
          )}
          {state.status === "ok" && (
            <>
              <div className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-900 flex items-center gap-2" data-testid="confirm-ok">
                <CheckCircle size={20} weight="fill" className="text-emerald-600" />
                <span>{state.message}{state.email ? ` (${state.email})` : ""}</span>
              </div>
              <Link to="/login" className="block"><Button className="w-full">Continue to sign in</Button></Link>
            </>
          )}
          {state.status === "error" && (
            <>
              <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-900 flex items-center gap-2" data-testid="confirm-err">
                <XCircle size={20} weight="fill" className="text-red-600" />
                <span>{state.message}</span>
              </div>
              <Link to="/login" className="block"><Button variant="outline" className="w-full">Back to sign in</Button></Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
